import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as engagementCharter from '../engagement-charter'

export const RESOURCE = {
  payload: {
    canBeOptional: false,
    context: core.dms.models.Attribute.Id.Context.from({
      context: engagementCharter.RESOURCE.payload.dimension.partialId,
      partialId: engagementCharter.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'When this engagement charter was generated or recorded.',
    isOptional: false,
    name: 'Recorded At',
    partialId: PartialId.Standard.create('recorded_at'),
    type: core.common.value.types.Intrinsic.Date,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
